/** HTTP status on a failed query's error (axios `response.status`), or null
 * when none came back (offline, aborted). */
export const httpStatusOf = (error: unknown): number | null => {
  const e = error as
    | { response?: { status?: number }; status?: number }
    | null
    | undefined;
  return e?.response?.status ?? e?.status ?? null;
};

/** A failed query's response body (axios `response.data`), or null. Error bodies skip the camelize interceptor. */
export const httpBodyOf = (error: unknown): Record<string, unknown> | null => {
  const d = (error as { response?: { data?: unknown } } | null | undefined)
    ?.response?.data;
  return d && typeof d === "object" ? (d as Record<string, unknown>) : null;
};
